import { Action } from '@ngrx/store';

export const MANUAL_SEARCH = '[Search] manual search';
export const AUTOCOMPLETE_SEARCH = '[Search] autocomplete search';
export const SET_IS_SEARCH_IN_PROGRESS = '[Search] set if search is in progress or not';
export const SET_CURRENT_SEARCH = '[Search] set the current query search';
export const ADD_CURRENT_SEARCH_TO_LAST_SEARCHES = '[Search] add current search into last searches array';
export const SET_SEARCH_VALUE = '[Search] set the searchbar value';

export class ManualSearch implements Action {
  readonly type = MANUAL_SEARCH;
  constructor(public payload: { query: string }) {}
}

export class AutocompleteSearch implements Action {
  readonly type = AUTOCOMPLETE_SEARCH;
  constructor(
    public payload: {
      query: string;
      contentId: string;
      contentType: 'autocomplete' | 'Product' | 'Brand';
    }
  ) {}
}

export class SetIsSearchInProgress implements Action {
  readonly type = SET_IS_SEARCH_IN_PROGRESS;

  constructor(public payload: boolean) {}
}

interface ICurrentSearch {
  query: string;
  nbHits: number;
  date: Date;
}

export class SetCurrentSearch implements Action {
  readonly type = SET_CURRENT_SEARCH;

  constructor(public payload: ICurrentSearch) {}
}

export class AddCurrentSearchToLastSearches implements Action {
  readonly type = ADD_CURRENT_SEARCH_TO_LAST_SEARCHES;

  constructor(public payload: ICurrentSearch) {}
}

export class SetSearchValue implements Action {
  readonly type = SET_SEARCH_VALUE;

  constructor(public payload: string) {}
}

export type SearchActions =
  | ManualSearch
  | AutocompleteSearch
  | SetIsSearchInProgress
  | SetCurrentSearch
  | AddCurrentSearchToLastSearches
  | SetSearchValue;
